export default "__VITE_ASSET__BOXnxmYI__"